export const config = {
  tokenKEY: "token",
  phoneKEY: "phone",
  backendTokenKEY: "Authorization",
};

export const CUSTOM_API_ROOT_PROD = "https://baby-boo-backend.bis-apps.com/";
export const CUSTOM_API_ROOT_TEST =
  "https://baby-boo-backend-test.bis-apps.com/";
